import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner, Alert } from 'react-bootstrap';
import { FaBriefcase, FaTruck, FaCheckCircle, FaClock, FaMapMarkerAlt, FaStopCircle, FaExclamationTriangle, FaHistory } from 'react-icons/fa';

const ModalHistorique = ({ show, onHide, camion }) => {

    const user_id = localStorage.getItem("userId");

    // États pour l'historique
    const [historique, setHistorique] = useState([]);
    const [chargementHistorique, setChargementHistorique] = useState(false);
    const [erreurHistorique, setErreurHistorique] = useState("");

    // Données d'historique simulées
    // const historique = [
    //     {
    //         date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    //         type: "creation",
    //         action: "Mise en file",
    //         title: "Enregistrement du camion",
    //         description: "Camion enregistré dans le système des tours internationaux",
    //         utilisateur: "ADMIN SYSTEM",
    //         details: {
    //             immatriculation: camion?.immatriculation || "N/A",
    //             parc: "Parc International"
    //         }
    //     },
    //     {
    //         date: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    //         type: "selection",
    //         action: "Sélection",
    //         title: "Camion sélectionné",
    //         description: "Sélectionné pour le fret REF-2025-001 - Destination: Cotonou",
    //         utilisateur: "Jean Dupont",
    //         details: {
    //             fret_ref: "REF-2025-001",
    //             destination: "Cotonou",
    //             poids: "25 T"
    //         }
    //     },
    //     {
    //         date: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    //         type: "arrivee_parc_tampon",
    //         action: "Arrivée parc tampon",
    //         title: "Arrivée au parc tampon",
    //         description: "Camion arrivé au parc tampon de Cotonou pour vérification Camion arrivé au parc tampon de Cotonou pour vérificationCamion arrivé au parc tampon de Cotonou pour vérification",
    //         utilisateur: "Marie Martin",
    //         details: {
    //             parc_tampon: "Parc Tampon Cotonou",
    //             verification: "Conforme"
    //         }
    //     },
    //     {
    //         date: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    //         type: "remplacement",
    //         action: "Remplacement conducteur",
    //         title: "Changement de conducteur",
    //         description: "Conducteur principal remplacé suite à indisponibilité",
    //         utilisateur: "Paul Kouassi",
    //         details: {
    //             ancien_conducteur: "KONE Ibrahim",
    //             nouveau_conducteur: "TRAORE Amadou"
    //         }
    //     },
    //     {
    //         date: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    //         type: "sortie",
    //         action: "Départ",
    //         title: "Camion en route",
    //         description: "Camion a quitté le parc tampon vers la destination finale",
    //         utilisateur: "Amadou Diallo",
    //         details: {
    //             heure_depart: "08:30",
    //             destination_finale: "Lomé"
    //         }
    //     },
    //     {
    //         date: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    //         type: "arrivee_parc_tampon",
    //         action: "Arrivée parc tampon",
    //         title: "Arrivée au parc tampon Lomé",
    //         description: "Camion arrivé au parc tampon de Lomé pour dédouanement",
    //         utilisateur: "Fatou Diop",
    //         details: {
    //             parc_tampon: "Parc Tampon Lomé",
    //             documents: "Complets"
    //         }
    //     },
    //     {
    //         date: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    //         type: "sortie",
    //         action: "Livraison",
    //         title: "Camion livré",
    //         description: "Marchandises livrées avec succès au destinataire final",
    //         utilisateur: "Moussa Camara",
    //         details: {
    //             destinataire: "TRANSPORT SARL",
    //             quantite_livree: "25 T",
    //             signature: "Confirmé"
    //         }
    //     }
    // ];


    // Fonction pour récupérer l'historique du camion
    const fetchHistoriqueCamion = async () => {
        if (!camion?.id) return;

        setChargementHistorique(true);
        setErreurHistorique("");

        try {
            const token = localStorage.getItem('access_token');
            const response = await fetch(`${process.env.REACT_APP_HOTE}/api/historique-tour/${camion.id}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error("Erreur lors de la récupération de l'historique");
            }

            const data = await response.json();
            setHistorique(data.historique || []);
        } catch (error) {
            console.error("Erreur lors du chargement de l'historique:", error);
            setErreurHistorique("Impossible de charger l'historique du camion");
        } finally {
            setChargementHistorique(false);
        }
    };

    // Charger l'historique quand le modal s'ouvre
    useEffect(() => {
        if (show && camion?.id) {
            fetchHistoriqueCamion();
        }
    }, [show, camion?.id]);


    const getImmatriculation = () => {
        if (!camion) return "Chargement...";
        if (camion.atellage === '1') {
            return `${camion.tete || 'N/A'} + ${camion.queue || 'N/A'}`;
        }
        return camion.immatriculation || 'N/A';
    };

    // Fonction pour formater la date
    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const optionsDate = { day: "2-digit", month: "2-digit", year: "numeric" };
        const optionsTime = { hour: "2-digit", minute: "2-digit", hour12: false };
        const formattedDate = date.toLocaleDateString("fr-FR", optionsDate);
        const formattedTime = date.toLocaleTimeString("fr-FR", optionsTime);
        return `${formattedDate} ${formattedTime}`;
    };

    // Calculer le temps écoulé
    const getTimeAgo = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);

        if (diffMins < 60) return `il y a ${diffMins} min`;
        const diffHours = Math.floor(diffMins / 60);
        if (diffHours < 24) return `il y a ${diffHours} h`;
        const diffDays = Math.floor(diffHours / 24);
        return `il y a ${diffDays} j`;
    };

    // Déterminer l'icône en fonction du type d'événement
    const getEventIcon = (type) => {
        switch (type) {
            case 'creation':
                return <FaTruck className="text-primary" />;
            case 'selection':
                return <FaCheckCircle className="text-success" />;
            case 'arrivee_parc_tampon':
                return <FaMapMarkerAlt className="text-info" />;
            case 'sortie':
                return <FaStopCircle className="text-danger" />;
            case 'remplacement':
                return <FaBriefcase className="text-warning" />;
            default:
                return <FaBriefcase className="text-navy" />;
        }
    };

    // Rendu de l'historique
    const renderHistorique = () => {
        if (chargementHistorique) {
            return (
                <div className="text-center py-5">
                    <Spinner animation="border" size="sm" />
                    <span className="ml-2">Chargement de l'historique...</span>
                </div>
            );
        }

        if (erreurHistorique) {
            return (
                <Alert variant="warning" className="m-3">
                    <FaExclamationTriangle className="mr-2" />
                    {erreurHistorique}
                </Alert>
            );
        }

        if (historique.length === 0) {
            return (
                <div className="text-center text-muted py-5">
                    <FaHistory size={40} className="mb-3 opacity-50" />
                    <p>Aucun historique disponible pour ce camion</p>
                </div>
            );
        }

        return (
            <div className="inspinia-timeline">
                {historique.map((event, index) => (
                    <div key={index} className="timeline-item">
                        <div className="row">
                            <div className="col-3 date">
                                {/* <i className="fa">{getEventIcon(event.type)}</i> */}
                                <FaTruck/>
                                {/* {formatDate(event.date_action)} */}
                                <br />
                                <small className="text-navy">
                                    {event.date_action}
                                </small>
                            </div>
                            <div className="col-7 content no-top-border">
                                <p className="m-b-xs">
                                    <strong>{event.title || event.action}</strong>
                                </p>
                                <p>{event.description}</p>
                                {event.acteur && (
                                    <small className="text-muted">
                                        <i className="fa fa-user mr-1"></i>
                                        {event.acteur}
                                    </small>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header >
                <Modal.Title>
                    <h3>
                        <FaHistory className="mr-2" />
                        Historique du parcours - Camion : {getImmatriculation()}
                        {camion?.ordre && <span className="ml-2 text-muted">(Tour N° {camion.ordre})</span>}
                    </h3>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="ibox">
                    <div className="ibox-title">
                        <h5>Timeline du parcours</h5>
                        {camion?.statut && (
                            <span className="label label-primary">
                                {camion.statut === "Disponible" ? "Disponible" :
                                    camion.statut === "Selectionne" ? "Chargement" :
                                        camion.statut === "Sorti" ? "Transport" :
                                            camion.statut === "Quitter" ? "Sorti de rang" :
                                                camion.statut === "En panne" ? "En panne" : camion.statut}
                            </span>
                        )}
                    </div>
                    <div className="ibox-content inspinia-timeline" style={{ maxHeight: "550px", overflowY: "auto" }}>
                        {renderHistorique()}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Fermer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalHistorique;